<template>
  <Form
    :error="error"
    :error-text="error"
    class="form-block-popup"
    @submit="submit"
  >
    <div class="top-window mb8">
      <div class="heading1 heading1-line">Отклонение заявки</div>
    </div>

    <div class="formcell">
      <label for="cancel-order-reason" class="label">
        Причина отклонения <span class="required">*</span>
      </label>
      <textarea
        v-model="reason"
        placeholder="Введите причину отклонения"
        maxlength="5000"
        id="cancel-order-reason"
        class="textarea w-input"
      />
    </div>

    <Submit
      :loading="isLoading"
      usual
      small
      text="Отклонить заявку"
    />
  </Form>
</template>

<script>
  import {mapActions} from 'vuex';
  import Form from '@/components/Form';
  import Submit from '@/components/Submit';
  import parseError from '@/utils/api/parse-error';
  import factory from '@/utils/api/factory';

  export default {
    name: 'EndOrder',
    components: {
      Submit,
      Form,
    },
    props: {
      context: {
        type: Object,
        default: () => ({
          id: null,
        }),
      },
    },
    data () {
      return {
        error: null,
        isLoading: false,
        reason: '',
      };
    },
    methods: {
      ...mapActions({
        close: 'modal/closeModal',
        reload: 'global/changeAction',
      }),
      async submit () {
        this.error = null;
        if (!this.reason) {
          this.error = 'Пожалуйста, введите причину.';
          return;
        }

        try {
          this.isLoading = true;
          await factory(`laboratory/orders/${this.context.id}/reject`).customPost({
            rejection_reason: this.reason,
          });
          await this.reload('reloadOrders');
          this.close();
          this.isLoading = false;
        } catch (e) {
          this.error = parseError(e) || 'Что-то пошло не так.';
          this.isLoading = false;
        }
      },
    },
  };
</script>

<style lang="scss">
  .popup-cancel {
    .btn-wrap {
      float: right;
      margin-bottom: 16px;
      input[type=submit] {
        width: 150px;
      }
      @media screen and (max-width: 480px) {
        input[type=submit] {
          width: 100%;
        }
      }
    }
    .w-form-fail {
      clear: both;
    }
  }
</style>
